import { render, staticRenderFns } from "./SectionCreateEditModal.vue?vue&type=template&id=c6fbc36a&scoped=true&"
import script from "./SectionCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./SectionCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionCreateEditModal.vue?vue&type=style&index=0&id=c6fbc36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fbc36a",
  null
  
)

/* custom blocks */
import block0 from "./SectionCreateEditModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardTitle,VContainer,VDialog,VForm,VSwitch})
